export default {"src":"/_next/static/media/rating-2.5.4440a6d6.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};